<template>
  <div>
    <v-dialog v-model="removeDialog" max-width="300">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir este padrão?') }}
          </div>

          <v-btn
            :disabled="removeLoading"
            class="ma-1"
            color="grey"
            text
            @click="removeDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="removeLoading"
            class="ma-1"
            color="error"
            text
            @click="removePattern"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="detailModal" max-width="1000">
      <PatternDetail
        :patternId="selectedId"
        :key="selectedId"
        @close="detailModal = false"
      />
    </v-dialog>

    <div class="d-flex justify-end">
      <v-btn
        class="primary-button ml-2"
        depressed
        @click="showFilter = !showFilter"
      >
        {{ showFilter ? 'Fechar filtros' : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-if="showFilter">
        <v-row class="ma-0" dense>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Instituição') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="institutionId"
              :items="institutions"
              item-value="id"
              item-text="name"
              :loading="institutionLoading"
              @change="getUnidades"
              :readonly="institution.userType != 0"
              outlined
              class="primary-input"
              disabled
              append-icon=""
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Unidade') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="unidadeId"
              :items="unidades"
              item-value="id"
              item-text="name"
              :loading="unidadeLoading"
              :disabled="!institutionId"
              @keyup.enter="filterTable"
              :placeholder="
                !institutionId ? $t('Selecione uma instituição') : ''
              "
              outlined
              class="primary-input"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <label class="label">{{ $t('Padrão') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="calibrationPatternName"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Modelo') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="calibrationPatternModel"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Fabricante') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="calibrationPatternManufacturer"
              :items="manufacturers"
              item-text="name"
              item-value="name"
              outlined
              append-icon="mdi-chevron-down"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Código patrimônio') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="calibrationPatternPropertyCode"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Número de Série') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="calibrationPatternSerialNumber"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Alienado') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="calibrationPatternAlienated"
              :items="alienatedOptions"
              item-text="text"
              item-value="value"
              :placeholder="$t('Não Alienados')"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" class="d-flex justify-end align-end">
            <v-btn
              class="mx-2 secondary-button"
              color="#BBCF20"
              @click="filterTable"
              depressed
            >
              <span>{{ $t('Filtrar') }}</span>
              <v-icon class="pl-2">mdi-magnify</v-icon>
            </v-btn>

            <v-btn
              depressed
              color="#20202066"
              class="clear-button"
              @click="reset"
            >
              <span>{{ $t('Limpar') }}</span>
              <v-icon class="pl-2">mdi-cached</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="patterns"
      class="main-table"
      hide-default-footer
      :items-per-page="pageSize"
      :loading="loading"
      :header-props="headerProps"
    >
      <template #[`item.name`]="{ item }">
        {{ item.name }}
      </template>

      <template #[`item.propertyCode`]="{ item }">
        {{ item.propertyCode }}
      </template>

      <template #[`item.model`]="{ item }">
        {{ item.model }}
      </template>

      <template #[`item.manufacturer`]="{ item }">
        {{ item.manufacturer }}
      </template>

      <template #[`item.serialNumber`]="{ item }">
        {{ item.serialNumber }}
      </template>

      <template #[`item.expirationDate`]="{ item }">
        <div class="d-flex flex-column align-center">
          <span>{{ formatDate(item.expirationDate) }}</span>
          <v-chip
            v-if="isExpired(item.expirationDate)"
            x-small
            color="error"
            dark
            class="mt-1"
          >
            Vencido
          </v-chip>
        </div>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              small
              color="#f5f5f5"
              dark
              @click="openDetail(item)"
              v-bind="attrs"
              v-on="on"
              depressed
              x-small
            >
              <v-icon color="#bbcf20">mdi-eye-outline</v-icon>
            </v-btn>
          </template>
          <span>Ficha vida</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              :color="
                item.uploadedDocuments && item.uploadedDocuments.length != 0
                  ? '#BBCF20'
                  : '#f5f5f5'
              "
              dark
              @click="uploadDocument(item)"
              v-bind="attrs"
              v-on="on"
              depressed
              small
            >
              <span style="font-size: 0.9rem">
                {{
                  item.uploadedDocuments.length != 0
                    ? item.uploadedDocuments.length
                    : ''
                }}
              </span>
              <v-icon
                small
                :class="
                  item.uploadedDocuments && item.uploadedDocuments.length != 0
                    ? 'ml-1'
                    : ''
                "
                :color="
                  item.uploadedDocuments && item.uploadedDocuments.length != 0
                    ? '#fff'
                    : '#BBCF20'
                "
              >
                mdi-file-document-multiple-outline
              </v-icon>
            </v-btn>
          </template>
          <span>Documentos Anexados</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="institution.userType != 5 && institution.userType != 4"
              class="ma-1"
              :color="item.metrics.length != 0 ? '#BBCF20' : '#f5f5f5'"
              :to="`/calibration/v2/pattern/manage?id=${item.id}`"
              v-bind="attrs"
              v-on="on"
              dark
              small
              depressed
            >
              <span style="font-size: 0.9rem">
                {{ item.metrics.length != 0 ? item.metrics.length : '' }}
              </span>
              <v-icon
                small
                :class="item.metrics.length != 0 ? 'ml-1' : ''"
                :color="item.metrics.length != 0 ? '#fff' : '#BBCF20'"
              >
                mdi-speedometer
              </v-icon>
            </v-btn>
          </template>
          <span>Métricas</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="institution.userType != 5 && institution.userType != 4"
              color="#0F3565"
              class="ma-1"
              dark
              small
              depressed
              v-bind="attrs"
              v-on="on"
              :to="`/calibration/v2/pattern/manage?id=${item.id}`"
            >
              <v-icon small>mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="institution.userType != 5 && institution.userType != 4"
              color="error"
              class="ma-1"
              dark
              small
              depressed
              v-bind="attrs"
              v-on="on"
              @click="openRemoveModal(item)"
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Remover') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../../services/ApiService'
import PatternDetail from '../pattern/patternDetail.vue'

export default {
  name: 'institutionPatternTable',

  components: {
    PatternDetail,
  },

  data() {
    return {
      institutions: [],
      institutionLoading: false,
      institution: {},
      institutionId: null,
      unidadeLoading: false,
      unidadeId: null,
      unidades: [],
      calibrationPatternName: null,
      calibrationPatternModel: null,
      calibrationPatternManufacturer: null,
      manufacturers: [],
      calibrationPatternPropertyCode: null,
      calibrationPatternSerialNumber: null,
      calibrationPatternAlienated: false,
      alienatedOptions: [
        { text: 'Todos', value: null },
        { text: 'Alienados', value: true },
        { text: 'Não alienados', value: false },
      ],
      patternId: null,
      removeLoading: false,
      removeDialog: false,
      showFilter: false,
      patterns: [],
      pageSize: 10,
      sizes: [10, 25, 50, 180],
      totalItems: 4,
      totalItensOnPage: 4,
      totalPages: 1,
      page: 1,
      loading: false,
      filter: {
        page: 1,
        pageSize: 10,
        name: null,
        institutionId: null,
        unidadeId: null,
        propertyCode: null,
        manufacturer: null,
        serialNumber: null,
        model: null,
        alienated: false,
      },
      apiService: new ApiService(),
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [
        { text: '', align: 'center', value: '', sortable: false },
        { text: 'Padrão', align: 'center', value: 'name', sortable: false },
        {
          text: 'Código Patrimônio',
          align: 'center',
          value: 'equipment.propertyCode',
          sortable: false,
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'equipment.model',
          sortable: false,
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'equipment.manufacturer',
          sortable: false,
        },
        {
          text: 'Nº Série',
          align: 'center',
          value: 'equipment.serialNumber',
          sortable: false,
        },
        {
          text: 'Validade',
          align: 'center',
          value: 'expirationDate',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      selectedId: null,
      detailModal: false,
    }
  },

  async created() {
    this.getInstitutions()
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id

    if (this.institutionId) {
      await Promise.all([this.getUnidades(), this.getManufacturers()])
    }

    this.list()
  },

  methods: {
    isExpired(date) {
      if (!date) return false
      return moment().isAfter(moment(date), 'day')
    },

    uploadDocument(pattern) {
      sessionStorage.clear()
      sessionStorage.setItem('calibrationV2Pattern', JSON.stringify(pattern))
      const url = this.$router.resolve({ path: '/uploadDocument' }).href
      window.open(url, '_blank')
    },

    openDetail(item) {
      this.selectedId = item.id
      this.detailModal = true
    },

    removePattern() {
      this.removeLoading = true

      this.apiService
        .delete(`calibration/v2/pattern/${this.patternId}`)
        .then(() => {
          this.filter.page = 1
          this.removeLoading = false
          this.removeDialog = false
          this.$toast.success('Template removido com sucesso!')
          this.list()
        })
        .catch(() => {
          this.removeLoading = false
        })
    },

    openRemoveModal(item) {
      this.patternId = item.id
      this.removeDialog = true
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.name = this.calibrationPatternName
      this.filter.propertyCode = this.calibrationPatternPropertyCode
      this.filter.manufacturer = this.calibrationPatternManufacturer
      this.filter.serialNumber = this.calibrationPatternSerialNumber
      this.filter.model = this.calibrationPatternModel
      this.filter.alienated = this.calibrationPatternAlienated
      this.list()
    },

    async list() {
      this.loading = true
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId

      await this.apiService
        .post('calibration/v2/pattern/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.patterns = response.content.data
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.data.length
        })
        .finally(() => {
          this.loading = false
        })
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        name: null,
        institutionId: this.institutionId,
        unidadeId: null,
        propertyCode: null,
        manufacturer: null,
        serialNumber: null,
        model: null,
        alienated: null,
      }
      this.institutionId = this.institutionId
      this.unidadeId = this.institution.userType > 1 ? this.unidadeId : null
      this.calibrationPatternName = null
      this.calibrationPatternPropertyCode = null
      this.calibrationPatternManufacturer = null
      this.calibrationPatternSerialNumber = null
      this.calibrationPatternModel = null
      this.calibrationPatternAlienated = null

      this.list()
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    getManufacturers() {
      this.manufacturerLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufacturerLoading = false
        })
        .catch(() => {
          this.manufacturerLoading = false
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    formatDate(date) {
      if (date) return moment(date).format('DD/MM/yyyy')
      else return 'Sem registro'
    },

    viewItem(item) {
      console.log('Visualizar item', item)
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.list()
    },
  },
}
</script>

<style></style>
